import React from 'react';
import ReactDOM from 'react-dom/client';
import TodayPageLifts from './TodayPageLifts';

const root = ReactDOM.createRoot(document.getElementById('today_page_lifts'));

root.render(
  <React.StrictMode>
    <TodayPageLifts />
  </React.StrictMode>
);
